/* ============================================================
 * MFF conversion additions (Claude, Aug 2026)
 * Loads on ALL pages. Self-contained & reversible: delete this file
 * and its <script> tag in layout/theme.liquid.
 *
 *  1. Cart-aware FREE-DELIVERY PROGRESS BAR — shown above Add-to-Cart on the
 *     product page AND inside the cart drawer, both driven by the live cart
 *     subtotal and the shopper's real market threshold. Auto-detected via
 *     Shopify.country + Shopify.currency — the shopper picks nothing.
 *  2. Product-page "frequently bought together" cross-sell — each page maps to
 *     its real top add-on from order history; add-on fetched live from the store.
 *  3. Hides Judge.me's empty "Be the first to write a review" widget.
 *
 *  Thresholds mirror the real Shopify shipping settings. Keep in sync if those
 *  change (Europe/DK-FI/UK/NO €70, Asia+RoW €110, SE 500 kr, US $75, CA CA$110, CH CHF75).
 * ============================================================ */
(function () {
  var S = window.Shopify || {};
  var cur = (S.currency && S.currency.active) || 'EUR';
  var rate = parseFloat((S.currency && S.currency.rate) || '1') || 1; /* active-currency units per 1 EUR */
  var country = S.country || '';
  var onProduct = /\/products\//.test(location.pathname);
  if (!onProduct) return; /* the drawer bar is the theme's own; we only enhance product pages */

  /* ---- market thresholds (real Shopify shipping settings) ---- */
  var NATIVE_THRESH = { SE: 500, US: 75, CA: 110, CH: 75 };
  var FAR125 = new Set(('AF AZ BH BD BT IO BN KH CN CX CC HK IN ID IQ IL JP JO KZ KW KG LA LB MO MY MV MN MM NP OM PK PS PH QA RU SA SG KR LK TW TJ TH TM AE UZ VN YE ' +
    'DZ AO AI AG AR AW BS BB BZ BJ BM BO BW BR BF BI CV BQ KY CF TD CL CO KM CG CD CK CR CI CW DJ DM DO EC EG SV GQ ER SZ ET FK FJ GF PF TF GA GM GH GD GT GN GW GY HT HN JM KE KI LS LR LY MG MW ML MQ MR MU MS MA MZ NA NR NC NI NE NG NU NF PA PG PY PE PN CM RW BL SH KN LC MF PM WS ST SN SC SL SX SB SO ZA GS SS VC SD SR TZ TL TG TK TO TT TN TC TV UG UY VU VE WF EH ZM ZW AC TA NZ MX VG AU').split(' '));
  function thresholdLocal() {
    if (NATIVE_THRESH[country] != null) return NATIVE_THRESH[country];
    var eur = FAR125.has(country) ? 110 : 70;
    return eur * rate;
  }

  /* ---- money formatting ---- */
  var SYMBOL = { USD: '$', GBP: '£', EUR: '€', CAD: 'CA$', AUD: 'A$', SGD: 'S$', CHF: 'CHF ' };
  function money(v, whole) {
    if (cur === 'SEK' || cur === 'NOK' || cur === 'DKK') return Math.round(v) + ' kr';
    var n = whole ? String(Math.round(v)) : (Math.round(v * 100) % 100 === 0 ? String(Math.round(v)) : v.toFixed(2));
    return (SYMBOL[cur] || (cur + ' ')) + n;
  }


  /* ---- Oct 2026: translations for the text this script writes (sv/de/es). English is the default. ---- */
  var LOC = String(S.locale || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var I18N = {
    sv: { fast: 'Snabb, spårbar leverans till {c}.', qualifies: 'Din order får <b>FRI FRAKT</b> till {c}.', shipsFree: 'Lägg till denna så får du <b>FRI FRAKT</b> till {c}.', over: '<b>Fri frakt</b> till {c} vid köp över <b>{t}</b>.', gapAdd: 'Lägg till denna — du är <b>{g}</b> från fri frakt.', gapYou: 'Du är <b>{g}</b> från fri frakt.', stat: 'Köps tillsammans av ~{p} % av {n}-köparna', add: 'Lägg till', adding: 'Lägger till…', added: 'Tillagd ✓', view: 'Visa varukorg →', choose: 'Välj alternativ', fms: 'Hitta min storlek', hideSg: 'Dölj storleksguide', atc: 'Lägg i varukorgen', soldOut: 'Slutsåld', country: 'ditt land',
      names: { SE: 'Sverige', US: 'USA', GB: 'Storbritannien', DE: 'Tyskland', NL: 'Nederländerna', FR: 'Frankrike', SG: 'Singapore', CA: 'Kanada', AU: 'Australien', IE: 'Irland', IT: 'Italien', DK: 'Danmark', NO: 'Norge', ES: 'Spanien', CH: 'Schweiz', FI: 'Finland' },
      blurb: { 'pedespocket': 'Fickstor tåspridare för rätt linjering var du än är.', 'foot-training-bands': 'Bygg styrka i fot, fotvalv och tår på några minuter om dagen.', 'toe-spacer-2-0': 'Båda tåspridarseten för full linjering av tårna.', 'toe-sock-crew': 'Femtåstrumpor i crew-längd som håller tårna utspridda.', 'toe-socks-ankle-copy': 'Femtåstrumpor i ankellängd för naturlig tåspridning.' } },
    de: { fast: 'Schneller Versand mit Sendungsverfolgung.', qualifies: 'Deine Bestellung wird <b>KOSTENLOS</b> geliefert.', shipsFree: 'Mit diesem Artikel ist dein <b>Versand KOSTENLOS</b>.', over: '<b>Kostenloser Versand</b> ab <b>{t}</b>.', gapAdd: 'Mit diesem Artikel fehlen dir noch <b>{g}</b> bis zum kostenlosen Versand.', gapYou: 'Dir fehlen noch <b>{g}</b> bis zum kostenlosen Versand.', stat: 'Von ~{p} % der {n}-Käufer dazugekauft', add: 'Hinzufügen', adding: 'Wird hinzugefügt…', added: 'Hinzugefügt ✓', view: 'Zum Warenkorb →', choose: 'Optionen wählen', fms: 'Meine Größe finden', hideSg: 'Größenhilfe ausblenden', atc: 'In den Warenkorb', soldOut: 'Ausverkauft', country: 'dein Land',
      names: {},
      blurb: { 'pedespocket': 'Zehenspreizer im Taschenformat – für unterwegs.', 'foot-training-bands': 'Stärke Füße, Fußgewölbe und Zehen in wenigen Minuten am Tag.', 'toe-spacer-2-0': 'Beide Spreizer-Sets für die volle Zehenausrichtung.', 'toe-sock-crew': 'Zehensocken in Crew-Länge, die deine Zehen frei lassen.', 'toe-socks-ankle-copy': 'Zehensocken in Knöchellänge für natürliche Zehenspreizung.' } },
    es: { fast: 'Envío rápido y con seguimiento a {c}.', qualifies: 'Tu pedido tiene <b>ENVÍO GRATIS</b> a {c}.', shipsFree: 'Añade este y tu pedido tendrá <b>ENVÍO GRATIS</b> a {c}.', over: '<b>Envío gratis</b> a {c} en pedidos de más de <b>{t}</b>.', gapAdd: 'Añade este: te faltarán <b>{g}</b> para el envío gratis.', gapYou: 'Te faltan <b>{g}</b> para el envío gratis.', stat: 'Lo añade ~{p} % de quienes compran {n}', add: 'Añadir', adding: 'Añadiendo…', added: 'Añadido ✓', view: 'Ver carrito →', choose: 'Elegir opciones', fms: 'Encontrar mi talla', hideSg: 'Ocultar guía de tallas', atc: 'Añadir al carrito', soldOut: 'Agotado', country: 'tu país',
      names: { SE: 'Suecia', US: 'EE. UU.', GB: 'Reino Unido', DE: 'Alemania', NL: 'Países Bajos', FR: 'Francia', SG: 'Singapur', CA: 'Canadá', AU: 'Australia', IE: 'Irlanda', IT: 'Italia', DK: 'Dinamarca', NO: 'Noruega', ES: 'España', CH: 'Suiza', FI: 'Finlandia' },
      blurb: { 'pedespocket': 'Separador de bolsillo para alinear los dedos estés donde estés.', 'foot-training-bands': 'Fortalece pies, arcos y dedos en pocos minutos al día.', 'toe-spacer-2-0': 'Los dos juegos de separadores para una alineación completa.', 'toe-sock-crew': 'Calcetines de cinco dedos, largo media caña, que dejan los dedos libres.', 'toe-socks-ankle-copy': 'Calcetines tobilleros de cinco dedos para una separación natural.' } }
  };
  var TX = I18N[LOC] || null;
  function fill(str, o) { return str.replace(/\{(\w)\}/g, function (m, k) { return o[k] != null ? o[k] : ''; }); }
  function L(k, en) { return (TX && TX[k]) || en; }
  window.__mffL = L;
  function statText(en) {
    if (!TX) return en;
    var m = /~(\d+)% of (.+) buyers/.exec(en);
    return m ? fill(TX.stat, { p: m[1], n: m[2] }) : en;
  }
  /* Translate the theme's own English Add to Cart / Sold out button text (product-page.liquid prints it in English). */
  function translateATC() {
    if (!TX) return;
    var b = document.querySelector('.mp-add-cart'); if (!b) return;
    function fix() {
      var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^add to cart/i.test(t)) b.textContent = TX.atc + ' →';
      else if (/^sold out/i.test(t)) b.textContent = TX.soldOut;
    }
    fix();
    if (!b.__mffObs) { b.__mffObs = new MutationObserver(fix); b.__mffObs.observe(b, { childList: true, characterData: true, subtree: true }); }
  }

  var NAMES = { SE: 'Sweden', US: 'the US', GB: 'the UK', DE: 'Germany', NL: 'the Netherlands', FR: 'France', SG: 'Singapore', CA: 'Canada', AU: 'Australia', IE: 'Ireland', IT: 'Italy', DK: 'Denmark', NO: 'Norway', ES: 'Spain', CH: 'Switzerland' };

  /* ---- data-driven cross-sell map (attach rates from real order history) ----
     Each product page maps to the ONE product most genuinely bought with it.
     `stat` = share of THIS product's buyers who also bought the add-on
     (rounded & conservative; measured from ~900 recent orders). Add-on details
     (title, price, image, variants) are fetched LIVE below so they always
     match the store — nothing about the add-on is hard-coded here. */
  var CROSS = {
    'toe-spacer-2-0':             { h: 'foot-training-bands',   stat: 'Added by ~40% of Toe Spacer Kit buyers' },
    'pedespocket':                { h: 'foot-training-bands',   stat: 'Added by ~39% of PedesPocket buyers' },
    'pedes':                      { h: 'pedespocket',           stat: 'Added by ~69% of PedesBoard buyers' },
    'toe-separators':             { h: 'pedespocket',           stat: 'Added by ~21% of Toe Separators buyers' },
    'toe-spacer-2-0-single-sets': { h: 'foot-training-bands',   stat: 'Added by ~25% of Single Set buyers' },
    'foot-training-bands':        { h: 'pedespocket',           stat: 'Added by ~67% of Foot Bands buyers' },
    'solespike':                  { h: 'pedespocket',           stat: 'Added by ~70% of SoleSpike buyers' },
    'stepflex-kinesiology-tape':  { h: 'pedespocket',           stat: 'Added by ~80% of StepFlex Tape buyers' },
    'toe-socks-ankle-copy':       { h: 'toe-sock-crew',         stat: 'Added by ~32% of Ankle Sock buyers' },
    'toe-sock-crew':              { h: 'toe-socks-ankle-copy',  stat: 'Added by ~25% of Crew Sock buyers' }
  };
  var BLURB = {
    'pedespocket': 'Pocket-sized spacer for alignment on the go.',
    'foot-training-bands': 'Build foot, arch & toe strength in minutes a day.',
    'toe-spacer-2-0': 'Both spacer sets for full toe alignment.',
    'toe-sock-crew': 'Five-toe crew socks that keep your toes splayed.',
    'toe-socks-ankle-copy': 'Five-toe ankle socks for natural toe splay.'
  };
  /* Add-ons with two option dimensions: pin one, let the shopper pick the other
     inline (one-click Add). PedesPocket: pin Size to the Original, offer Colour.
     Any 2-option add-on NOT listed here falls back to a "Choose options" link
     (e.g. socks, where both size and colour genuinely matter). */
  var ADDON_CFG = {
    'pedespocket': { pin: { 'Size': 'PedesPocket Original' }, show: 'Colour', prefer: 'Black' }
  };
  function currentHandle() {
    var m = location.pathname.split('/products/')[1];
    return m ? m.split('/')[0].split('?')[0] : '';
  }

  /* ---- styles (injected so they work globally, incl. the cart drawer) ---- */
  function injectCSS() {
    if (document.getElementById('mff-conv-css')) return;
    var s = document.createElement('style'); s.id = 'mff-conv-css';
    s.textContent =
      ".mff-ship{display:flex;align-items:flex-start;gap:8px;background:#EEF7F0;border:1px solid #CFE9D6;border-radius:9px;padding:10px 13px;margin:12px 0;font-family:'Outfit',sans-serif;font-size:.86rem;line-height:1.4;color:#1A6B4A;font-weight:600}" +
      ".mff-ship b{color:#14512F}.mff-ship__ic{flex:0 0 auto;font-size:1rem;line-height:1.2}" +
      ".mff-ship__bar{display:block;height:6px;background:#D2E8D8;border-radius:6px;margin-top:7px;overflow:hidden}" +
      ".mff-ship__bar i{display:block;height:100%;background:#1F8A54;border-radius:6px;transition:width .45s ease}" +
      ".mff-ship--free{background:#E7F6EC;border-color:#BEE3C8}" +
      ".mff-ship--drawer{margin:0 0 12px}" +
      ".mff-x{display:flex;gap:12px;align-items:center;background:#FDF6F1;border:1px solid #EFD9C9;border-radius:10px;padding:10px 12px;margin:0 0 14px;font-family:'Outfit',sans-serif}" +
      ".mff-x__img{width:54px;height:54px;border-radius:8px;object-fit:cover;background:#fff;flex:0 0 auto;border:1px solid #EFE3DA}" +
      ".mff-x__body{flex:1 1 auto;min-width:0}.mff-x__stat{font-size:.68rem;font-weight:700;letter-spacing:.02em;text-transform:uppercase;color:#B85C38;margin-bottom:1px}" +
      ".mff-x__title{font-size:.92rem;font-weight:700;color:#1A1614}.mff-x__price{color:#6A5F58;font-weight:600}" +
      ".mff-x__blurb{font-size:.76rem;color:#6A5F58;margin:1px 0 6px;line-height:1.3}" +
      ".mff-x__ctrls{display:flex;align-items:center;gap:6px;flex-wrap:wrap}.mff-x__lbl{font-size:.72rem;color:#8A7F78;font-weight:600}" +
      ".mff-x__sw{width:20px;height:20px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px #D9CFC8;cursor:pointer;padding:0}.mff-x__sw.on{box-shadow:0 0 0 2px #B85C38}" +
      ".mff-x__pill{border:1px solid #D9CFC8;background:#fff;border-radius:6px;padding:3px 9px;font-size:.75rem;font-weight:600;color:#1A1614;cursor:pointer}.mff-x__pill.on{border-color:#B85C38;background:#F7E9E0;color:#8A3F22}" +
      ".mff-x__add{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;line-height:1;text-align:center;background:#B85C38;color:#fff;border:none;border-radius:8px;padding:11px 18px;font-size:.85rem;font-weight:700;cursor:pointer;font-family:'Outfit',sans-serif}.mff-x__add:hover{background:#9C4A2B}.mff-x__add.done{background:#1A6B4A}" +
      ".mff-x__view{display:inline-block;margin-top:4px;font-size:.75rem;font-weight:700;color:#B85C38;text-decoration:underline}" +
      "@media(max-width:560px){.mff-x{flex-wrap:wrap}.mff-x__add{width:100%;margin-top:6px}}";
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---- progress bar ---- */
  /* Item-centric bar: framed around adding THIS product, and accounts for
     anything already in the cart. */
  function bar(pct) { return '<span class="mff-ship__bar"><i style="width:' + pct + '%"></i></span>'; }
  function barHTML(sub) {
    var t = thresholdLocal(), name = TX ? ((TX.names && TX.names[country]) || TX.country) : (NAMES[country] || 'your country');
    if (!t) return '<span class="mff-ship__ic">🚚</span><span>' + (TX ? fill(TX.fast, { c: name }) : 'Fast, tracked delivery to ' + name + '.') + '</span>';
    if (sub >= t) return '<span class="mff-ship__ic">✓</span><span>' + (TX ? fill(TX.qualifies, { c: name }) : 'Your order qualifies for <b>FREE delivery</b> to ' + name + '.') + '</span>';
    var pp = productLocal || 0;
    var projected = sub + pp;
    if (pp > 0 && projected >= t) return '<span class="mff-ship__ic">✓</span><span>' + (TX ? fill(TX.shipsFree, { c: name }) : 'Add this and your order ships <b>FREE</b> to ' + name + '.') + bar(100) + '</span>';
    var base = projected > 0 ? projected : sub;
    /* Oct 2026: on a small item far below the threshold (e.g. $7.99 bands vs $75),
       "you'll be $67 from FREE delivery" mostly advertises a shipping charge.
       State the threshold plainly instead. */
    if (pp > 0 && projected < t * 0.5) return '<span class="mff-ship__ic">🚚</span><span>' + (TX ? fill(TX.over, { c: name, t: money(t, true) }) : 'FREE delivery to ' + name + ' on orders over <b>' + money(t, true) + '</b>.') + '</span>';
    var gap = t - base, pct = Math.max(4, Math.min(100, Math.round(base / t * 100)));
    var lead = pp > 0 ? 'Add this — you\'ll be ' : 'You\'re ';
    if (TX) return '<span class="mff-ship__ic">🚚</span><span>' + fill(pp > 0 ? TX.gapAdd : TX.gapYou, { g: money(gap, false) }) + bar(pct) + '</span>';
    return '<span class="mff-ship__ic">🚚</span><span>' + lead + '<b>' + money(gap, false) + '</b> from FREE delivery.' + bar(pct) + '</span>';
  }
  var lastSub = null;
  function renderAll(sub) {
    var t = thresholdLocal();
    var els = document.querySelectorAll('.mff-ship');
    for (var i = 0; i < els.length; i++) { els[i].classList.toggle('mff-ship--free', !!t && sub >= t); els[i].innerHTML = barHTML(sub); }
  }
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      lastSub = (c.total_price || 0) / 100; renderAll(lastSub);
    }).catch(function () { if (lastSub == null) { lastSub = 0; renderAll(0); } });
  }
  var productLocal = null;
  var productData = null;
  function fetchProduct() {
    fetch('/products/' + currentHandle() + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
      productLocal = (p && p.price != null) ? p.price / 100 : null;
      productData = p;
      renderAll(lastSub == null ? 0 : lastSub);
    }).catch(function () {});
  }


  var SG_HTML = "<div class=\"mff-sg-wrap\" style=\"--mff-o:#C4714A;--mff-od:#A55A37;--mff-ol:#FBE8DC;--mff-dk:#1A1614;--mff-mi:#6A5A50;--mff-li:#9A8A7A;--mff-cr:#F5F0EB;--mff-sa:#EDE5D8;--mff-wh:#FEFCFA;--mff-gr:#1A6B4A;--mff-gl:#EAF2ED;--mff-pp:#D4E84A;font-family:'Outfit',sans-serif;color:#1A1614;box-sizing:border-box;\"><div style=\"max-width:640px;margin:16px auto 6px;padding:18px 20px;border:1px solid var(--mff-sa);border-radius:12px;background:var(--mff-wh);\"><div style=\"font-size:0.95rem;font-weight:800;letter-spacing:-0.01em;margin-bottom:4px;color:var(--mff-dk);\">Find your size</div><p style=\"font-size:0.8rem;color:var(--mff-mi);margin:0 0 14px;line-height:1.5;\">Your kit includes toe spacers &mdash; check your size before ordering.</p>        <div style=\"display:flex;gap:6px;margin-bottom:12px;\"><button onclick=\"mffSgTab(this,'mff-sg-calc-sp','mff-sg-table-sp')\" style=\"background:var(--mff-o);border:1px solid var(--mff-o);border-radius:6px;padding:6px 12px;font-family:'Outfit',sans-serif;font-size:0.76rem;font-weight:600;cursor:pointer;color:#fff;\">Find my size</button><button onclick=\"mffSgTab(this,'mff-sg-table-sp','mff-sg-calc-sp')\" style=\"background:var(--mff-cr);border:1px solid var(--mff-sa);border-radius:6px;padding:6px 12px;font-family:'Outfit',sans-serif;font-size:0.76rem;font-weight:600;cursor:pointer;color:var(--mff-mi);\">Size chart</button></div>\n        <div id=\"mff-sg-calc-sp\"><label style=\"font-size:0.79rem;font-weight:600;color:var(--mff-dk);display:block;margin-bottom:6px;\">Enter your shoe size</label><div style=\"display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-bottom:8px;\"><div><div style=\"font-size:0.68rem;color:var(--mff-li);margin-bottom:3px;font-weight:600;\">US</div><input type=\"number\" id=\"mff-sg-sp-us\" placeholder=\"e.g. 9\" min=\"4\" max=\"16\" step=\"0.5\" style=\"width:100%;padding:8px 10px;border:1px solid var(--mff-sa);border-radius:7px;font-family:'Outfit',sans-serif;font-size:0.86rem;color:var(--mff-dk);background:#fff;outline:none;\"></div><div><div style=\"font-size:0.68rem;color:var(--mff-li);margin-bottom:3px;font-weight:600;\">EU</div><input type=\"number\" id=\"mff-sg-sp-eu\" placeholder=\"e.g. 42\" min=\"34\" max=\"50\" step=\"1\" oninput=\"var v=parseInt(this.value);if(!isNaN(v)){document.getElementById('mff-sg-sp-us').value=Math.round((v-33)*2)/2;document.getElementById('mff-sg-sp-uk').value=Math.round((v-33.5)*2)/2;}\" style=\"width:100%;padding:8px 10px;border:1px solid var(--mff-sa);border-radius:7px;font-family:'Outfit',sans-serif;font-size:0.86rem;color:var(--mff-dk);background:#fff;outline:none;\"></div><div><div style=\"font-size:0.68rem;color:var(--mff-li);margin-bottom:3px;font-weight:600;\">UK</div><input type=\"number\" id=\"mff-sg-sp-uk\" placeholder=\"e.g. 8\" min=\"2\" max=\"14\" step=\"0.5\" oninput=\"var v=parseFloat(this.value);if(!isNaN(v)){document.getElementById('mff-sg-sp-eu').value=Math.round(v+33.5);document.getElementById('mff-sg-sp-us').value=Math.round((v+0.5)*2)/2;}\" style=\"width:100%;padding:8px 10px;border:1px solid var(--mff-sa);border-radius:7px;font-family:'Outfit',sans-serif;font-size:0.86rem;color:var(--mff-dk);background:#fff;outline:none;\"></div></div><button onclick=\"mffSgFind('sp')\" style=\"background:var(--mff-o);color:#fff;border:none;padding:9px 18px;border-radius:7px;font-family:'Outfit',sans-serif;font-size:0.82rem;font-weight:700;cursor:pointer;\">Find my size &rarr;</button><div id=\"mff-sg-sp-res\" style=\"display:none;\"></div><p style=\"font-size:0.73rem;color:var(--mff-li);margin-top:10px;line-height:1.6;\">EU is exact. A US size shows both women’s and men’s.</p></div>\n        <div id=\"mff-sg-table-sp\" style=\"display:none;\"><table style=\"width:100%;border-collapse:collapse;font-size:0.76rem;\"><thead><tr><th style=\"background:var(--mff-dk);color:#fff;padding:7px 8px;text-align:left;\">Size</th><th style=\"background:var(--mff-dk);color:#fff;padding:7px 8px;text-align:left;\">EU</th><th style=\"background:var(--mff-dk);color:#fff;padding:7px 8px;text-align:left;\">US (W)</th><th style=\"background:var(--mff-dk);color:#fff;padding:7px 8px;text-align:left;\">US (M)</th><th style=\"background:var(--mff-dk);color:#fff;padding:7px 8px;text-align:left;\">UK</th></tr></thead><tbody><tr><td style=\"padding:7px 8px;border-bottom:1px solid var(--mff-sa);\"><strong>XS&ndash;S</strong></td><td style=\"padding:7px 8px;border-bottom:1px solid var(--mff-sa);\">36&ndash;41</td><td style=\"padding:7px 8px;border-bottom:1px solid var(--mff-sa);\">6&ndash;9.5</td><td style=\"padding:7px 8px;border-bottom:1px solid var(--mff-sa);\">5&ndash;8.5</td><td style=\"padding:7px 8px;border-bottom:1px solid var(--mff-sa);\">4&ndash;7</td></tr><tr><td style=\"padding:7px 8px;\"><strong>M&ndash;L</strong></td><td style=\"padding:7px 8px;\">42&ndash;46</td><td style=\"padding:7px 8px;\">10&ndash;12+</td><td style=\"padding:7px 8px;\">9&ndash;13</td><td style=\"padding:7px 8px;\">8&ndash;12</td></tr></tbody></table><p style=\"font-size:0.73rem;color:var(--mff-li);margin-top:10px;line-height:1.6;\">EU sizing is unisex and exact. US &amp; UK differ for women vs men &mdash; use your own column.</p></div></div></div>";
  window.mffSgTab = function(btn,showId,hideId){var b=btn.parentElement;b.querySelectorAll('button').forEach(function(x){x.style.cssText='background:var(--mff-cr);border:1px solid var(--mff-sa);border-radius:6px;padding:6px 12px;font-family:Outfit,sans-serif;font-size:0.76rem;font-weight:600;cursor:pointer;color:var(--mff-mi)';});btn.style.cssText='background:var(--mff-o);border:1px solid var(--mff-o);border-radius:6px;padding:6px 12px;font-family:Outfit,sans-serif;font-size:0.76rem;font-weight:600;cursor:pointer;color:#fff';var s=document.getElementById(showId),h=document.getElementById(hideId);if(s)s.style.display='block';if(h)h.style.display='none';}
  window.mffSgBk = function(p,ref){if(p==='sp'){return ref<=41?'Extra Small – Small (XS–S)':'Medium – Large (M–L)';}if(p==='sep'){return ref<=40?'Small':ref<=43?'Medium':'Large';}return ref<=40?'Extra Small – Small (XS–S)':ref<=43?'Medium (M)':'Large – Extra Large (L–XL)';}
  window.mffSgUw = function(p,us){if(p==='sp'){return us<=9.5?'Extra Small – Small (XS–S)':'Medium – Large (M–L)';}if(p==='sep'){return us<=9?'Small':us<=12.5?'Medium':'Large';}return us<=8.5?'Extra Small – Small (XS–S)':us<=11.5?'Medium (M)':'Large – Extra Large (L–XL)';}
  window.mffSgUm = function(p,us){if(p==='sp'){return us<=8.5?'Extra Small – Small (XS–S)':'Medium – Large (M–L)';}if(p==='sep'){return us<=7?'Small':us<=10?'Medium':'Large';}return us<=7.5?'Extra Small – Small (XS–S)':us<=10.5?'Medium (M)':'Large – Extra Large (L–XL)';}
  window.mffSgFind = function(p){var eu=parseInt(document.getElementById('mff-sg-'+p+'-eu').value),us=parseFloat(document.getElementById('mff-sg-'+p+'-us').value),uk=parseFloat(document.getElementById('mff-sg-'+p+'-uk').value),r=document.getElementById('mff-sg-'+p+'-res');function ok(t){r.style.cssText='display:block;background:#EAF5EE;border:1px solid #B8DFC4;border-radius:7px;padding:10px 14px;font-size:0.83rem;color:#1A4A2A;font-weight:600;margin-top:8px;';r.textContent=t;}function er(t){r.style.cssText='display:block;background:#FBE8DC;border:1px solid var(--mff-o);border-radius:7px;padding:10px 14px;font-size:0.83rem;color:#8A3A20;font-weight:600;margin-top:8px;';r.textContent=t;}if(!isNaN(eu)){if(eu<30||eu>52){er('Please enter a valid EU size.');}else{ok('Your size: '+mffSgBk(p,eu));}return;}if(!isNaN(uk)){ok('Your size: '+mffSgBk(p,Math.round(uk+33)));return;}if(!isNaN(us)){var w=mffSgUw(p,us),m=mffSgUm(p,us);ok(w===m?'Your size: '+w:'Women’s US → '+w+'    ·    Men’s US → '+m);}else{er('Please enter your US, EU or UK size.');}}
  function ensureSizeGuide(){
    if(!onProduct) return;
    if(document.getElementById('mff-sg-injected')) return;
    if(document.getElementById('sg-table-sp')||document.getElementById('sg-calc-sp')) return;
    if(!productData) return;
    var vals=[];
    (productData.variants||[]).forEach(function(v){ [v.option1,v.option2,v.option3].forEach(function(x){ if(x) vals.push(x); }); });
    if(!vals.some(function(x){ return /extra small\s*-\s*small|medium\s*-\s*large/i.test(x); })) return;
    var atc = document.querySelector('.mp-add-cart') || document.querySelector('.product-form__submit[name="add"]') || document.querySelector('form.product-form button[name="add"], form[data-type="add-to-cart-form"] button[name="add"]');
    if(atc && atc.closest('product-recommendations, .complementary-products, .horizontal-product, .mff-x')) atc=null;
    if(!atc) return;
    var wrap=document.createElement('div'); wrap.id='mff-sg-injected'; wrap.innerHTML=SG_HTML;
    var grp2 = atc.closest('.product-form__buttons') || atc;
    grp2.parentNode.insertBefore(wrap, grp2.nextSibling);
  }

  function ensurePDPBar() {
    if (!onProduct || document.querySelector('.mff-ship--pdp')) return;
    var atc = document.querySelector('.mp-add-cart')
      || document.querySelector('.product-form__submit[name="add"]')
      || document.querySelector('form.product-form button[name="add"], form[data-type="add-to-cart-form"] button[name="add"]');
    if (atc && atc.closest('product-recommendations, .complementary-products, .horizontal-product, .mff-x')) atc = null;
    if (!atc) return;
    var el = document.createElement('div'); el.className = 'mff-ship mff-ship--pdp';
    el.innerHTML = barHTML(lastSub == null ? 0 : lastSub);
    var grp = atc.closest('.product-form__buttons') || atc;
    grp.parentNode.insertBefore(el, grp);
  }
  /* NOTE: the theme already ships a free-delivery progress bar inside the cart
     drawer ("Spend X more to reach free shipping"), so we do NOT add one there —
     that would duplicate it. We only add the bar to the product page. */

  /* ---- cross-sell (product page): pick THIS page's real top add-on, fetch it
     live, and render an accurate card. ---- */
  function buildCross() {
    try {
      if (document.querySelector('.mff-x')) return true;
      var anchor = document.querySelector('.mff-ship--pdp');
      if (!anchor) return false;
      var h = currentHandle();
      var map = CROSS[h];
      if (!map || h === map.h) return true; /* no genuine pairing for this page */
      fetch('/products/' + map.h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (!p || !p.variants || !p.variants.length || document.querySelector('.mff-x')) return;
          renderCross(anchor, map, p);
        }).catch(function () {});
      return true;
    } catch (e) { return true; }
  }

  function renderCross(anchor, map, p) {
    var variants = p.variants || [];
    if (!variants.length) return;
    var optionNames = (p.options || []).map(function (o) { return (o && o.name) ? o.name : o; });
    var cfg = ADDON_CFG[p.handle];

    function optVal(v, name) { var i = optionNames.indexOf(name); return i < 0 ? null : v['option' + (i + 1)]; }
    function pushUnique(list, seen, label, v) { if (label == null || seen[label]) return; seen[label] = 1; list.push({ label: label, id: v.id, price: v.price, available: v.available }); }

    /* Decide how the shopper picks a variant: inline pills (choices), a link to
       the product page (linkMode), or a plain Add (single variant). */
    var choices = null, controlLabel = '', linkMode = false;
    if (cfg && optionNames.indexOf(cfg.show) > -1) {
      var pinned = variants.filter(function (v) { return Object.keys(cfg.pin).every(function (n) { return optVal(v, n) === cfg.pin[n]; }); });
      if (pinned.length) { choices = []; var sA = {}; pinned.forEach(function (v) { pushUnique(choices, sA, optVal(v, cfg.show), v); }); controlLabel = cfg.show; }
    } else if (optionNames.length === 1 && variants.length > 1) {
      choices = []; var sB = {}; variants.forEach(function (v) { pushUnique(choices, sB, v.option1, v); }); controlLabel = optionNames[0];
    } else if (optionNames.length > 1) {
      linkMode = true; /* 2+ options, no inline config → send to product page */
    }

    /* Default selection */
    var def = null;
    if (choices) {
      if (cfg && cfg.prefer) def = choices.filter(function (c) { return c.label === cfg.prefer && c.available; })[0];
      if (!def) def = choices.filter(function (c) { return c.available; })[0];
      if (!def) def = choices[0];
    } else if (!linkMode) {
      for (var i = 0; i < variants.length; i++) { if (variants[i].available) { def = { id: variants[i].id, price: variants[i].price }; break; } }
      if (!def) def = { id: variants[0].id, price: variants[0].price };
    }
    var selId = def ? def.id : null;
    var selPrice = (def && def.price != null) ? def.price : p.price;

    var img = p.featured_image || (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var blurb = (TX && TX.blurb[map.h]) || BLURB[map.h] || '';

    var ctrlHTML = '';
    if (choices) {
      var pills = choices.map(function (c) {
        return '<button type="button" class="mff-x__pill' + (c.id === selId ? ' on' : '') + '"' +
               (c.available ? '' : ' disabled style="opacity:.4;cursor:not-allowed"') +
               ' data-id="' + c.id + '" data-price="' + (c.price != null ? c.price : '') + '">' + c.label + '</button>';
      }).join('');
      ctrlHTML = '<div class="mff-x__ctrls"><span class="mff-x__lbl">' + controlLabel + ':</span> ' + pills + '</div>';
    }

    var actionHTML = linkMode
      ? '<a class="mff-x__add" href="/products/' + p.handle + '">' + L('choose', 'Choose options') + '</a>'
      : '<button type="button" class="mff-x__add">' + L('add', 'Add') + '</button>';

    var card = document.createElement('div'); card.className = 'mff-x';
    card.innerHTML =
      '<img class="mff-x__img" src="' + img + '" alt="' + (p.title || '') + '">' +
      '<div class="mff-x__body"><div class="mff-x__stat">' + statText(map.stat) + '</div>' +
      '<div class="mff-x__title">' + p.title + ' · <span class="mff-x__price">' + money((selPrice != null ? selPrice : 0) / 100, false) + '</span></div>' +
      '<div class="mff-x__blurb">' + blurb + '</div>' +
      ctrlHTML + '</div>' + actionHTML;
    anchor.parentNode.insertBefore(card, anchor.nextSibling);

    card.querySelectorAll('.mff-x__pill[data-id]').forEach(function (b) {
      if (b.disabled) return;
      b.addEventListener('click', function () {
        card.querySelectorAll('.mff-x__pill[data-id]').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on'); selId = b.getAttribute('data-id');
        var pr = b.getAttribute('data-price');
        if (pr) card.querySelector('.mff-x__price').textContent = money(Number(pr) / 100, false);
      });
    });

    if (!linkMode) {
      var addBtn = card.querySelector('.mff-x__add');
      addBtn.addEventListener('click', function () {
        if (!selId) return;
        addBtn.disabled = true; addBtn.textContent = L('adding', 'Adding…');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(selId), quantity: 1 }] }) })
          .then(function (r) { return r.json(); })
          .then(function () {
            addBtn.textContent = L('added', 'Added ✓'); addBtn.classList.add('done');
            if (!card.querySelector('.mff-x__view')) { var vw = document.createElement('a'); vw.className = 'mff-x__view'; vw.href = '/cart'; vw.textContent = L('view', 'View cart →'); card.querySelector('.mff-x__body').appendChild(vw); }
            refresh();
          })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = L('add', 'Add'); });
      });
    }
  }

  /* ---- hide empty Judge.me widget (product page) ---- */
  function hideEmptyReviews() {
    if (!onProduct) return;
    var w = document.querySelectorAll('.jdgm-rev-widg, .jdgm-widget');
    for (var i = 0; i < w.length; i++) {
      if (!w[i].querySelector('.jdgm-rev') && /be the first to write a review/i.test(w[i].textContent || '')) w[i].style.display = 'none';
    }
  }

  /* ---- re-render on any cart change ---- */
  var _fetch = window.fetch;
  window.fetch = function () {
    var p = _fetch.apply(this, arguments);
    try {
      var u = (arguments[0] && arguments[0].url) || arguments[0] || '';
      if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) { p.then(function () { setTimeout(refresh, 200); }); }
    } catch (e) {}
    return p;
  };

  injectCSS();
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    ensurePDPBar();
    ensureSizeGuide();
    translateATC();
    if (onProduct) buildCross();
    if (tries >= 8) hideEmptyReviews();
    if (tries > 40) clearInterval(iv);
  }, 250);
  refresh(); fetchProduct();
  document.addEventListener('DOMContentLoaded', function () { injectCSS(); ensurePDPBar(); refresh(); fetchProduct(); });
})();

/* ============================================================
 * MFF mobile product page (Claude, Oct 2026)
 * Based on Clarity data (Oct 2026): on phones only ~45% of Kit visitors
 * scrolled far enough to see Add to Cart, and size tools got ~7x more taps
 * than the buy button. On phones only (<750px) and only on the custom
 * product template (.mp-info), this script:
 *   1. Moves the price up under the product name.
 *   2. Moves "Similar products" and the "frequently bought together" card
 *      below Add to Cart, and shrinks the gallery (one row of thumbnails).
 *   3. Puts a "Find my size" link next to the Size label that opens the size
 *      guide right under the size buttons.
 *   4. Adds a sticky Add to Cart bar (price + chosen options) whenever the
 *      real button is off screen. It presses the real button, so variant
 *      checks, cart drawer and analytics behave exactly as before.
 * Reversible: delete this file and its <script> tag in layout/theme.liquid.
 * ============================================================ */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

  function q(s, r) { return (r || document).querySelector(s); }
  var L = window.__mffL || function (k, en) { return en; };

  function css() {
    if (q('#mff-pdpm-css')) return;
    var s = document.createElement('style'); s.id = 'mff-pdpm-css';
    s.textContent =
      ".mp .mp-gal-main{max-height:280px!important;aspect-ratio:auto!important;justify-content:center}" +
      ".mp .mp-gal-main img,.mp .mp-gal-main video{max-height:280px!important;width:auto!important;max-width:100%!important;object-fit:contain!important;margin:0 auto}" +
      ".mp .mp-thumbs{flex-wrap:nowrap!important;overflow-x:auto!important;-webkit-overflow-scrolling:touch;scrollbar-width:none;gap:6px!important;padding-bottom:2px}" +
      ".mp .mp-thumbs::-webkit-scrollbar{display:none}" +
      ".mp .mp-thumbs>.mp-thumb{flex:0 0 54px!important;width:54px!important;height:54px!important}" +
      ".mff-pdpm-price{display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 10px;margin:2px 0 10px}" +
      ".mff-pdpm-price .mp-price-note{font-size:.72rem}" +
      ".mp .mp-var-label a.mff-pdpm-fms{display:inline-block!important;margin-left:auto;font-size:.78rem;font-weight:700;color:var(--mff-o,#C4714A);text-decoration:underline;text-underline-offset:2px;cursor:pointer}" +
      "#mff-trust-size-guide.mff-pdpm-sg{display:none!important;margin-top:10px}" +
      "#mff-trust-size-guide.mff-pdpm-sg.open{display:block!important}" +
      "#mff-trust-size-guide.mff-pdpm-sg>div:first-child{display:none!important}" +
      "#mff-trust-size-guide.mff-pdpm-sg>div:nth-child(2){display:block!important}" +
      ".mff-pdpm-after{margin-top:14px}" +
      ".mff-sticky{position:fixed;left:0;right:0;bottom:0;z-index:26;display:flex;align-items:center;gap:10px;padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));background:#FEFCFA;border-top:1px solid #EDE5D8;box-shadow:0 -6px 18px rgba(26,22,20,.08);font-family:'Outfit',sans-serif;transform:translateY(110%);transition:transform .22s ease;pointer-events:none}" +
      ".mff-sticky.on{transform:none;pointer-events:auto}" +
      ".mff-sticky__info{flex:1 1 auto;min-width:0;line-height:1.2}" +
      ".mff-sticky__price{display:block;font-weight:800;font-size:1rem;color:#1A1614;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      ".mff-sticky__opt{display:block;font-size:.72rem;color:#6A5A50;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      ".mff-sticky__btn{flex:0 0 auto;background:#C4714A;color:#fff;border:0;border-radius:8px;padding:13px 20px;font-family:'Outfit',sans-serif;font-size:.92rem;font-weight:700;cursor:pointer}" +
      ".mff-sticky__btn:active{background:#A55A37}.mff-sticky__btn[disabled]{background:#B9ACA2}" +
      ".has-modal-open .mff-sticky,.has-modal-opening .mff-sticky{display:none!important}" +
      "body.mff-sticky-on div[class*=\"kl-teaser-\"]{bottom:calc(var(--mff-sticky-bottom,0px) + 82px)!important}" +
      "body.mff-sticky-on{padding-bottom:72px}";
    (document.head || document.documentElement).appendChild(s);
  }

  /* 1. price under the name */
  function movePrice(info) {
    if (q('.mff-pdpm-price')) return;
    var name = q('.mp-name', info), price = q('#mp-price', info);
    if (!name || !price) return;
    var kids = [].slice.call(info.children).filter(function (el) {
      var c = (el.className || '').toString();
      return el.id === 'mp-price' || /(^|\s)mp-(price|compare|was|save)/.test(c);
    });
    var wrap = document.createElement('div'); wrap.className = 'mff-pdpm-price';
    name.parentNode.insertBefore(wrap, name.nextSibling);
    kids.forEach(function (el) { wrap.appendChild(el); });
  }

  /* 2. similar products + cross-sell below Add to Cart */
  function anchorAfterBuy(info) {
    return q('.mp-secure-inline', info) || q('form.shopify-product-form', info);
  }
  function moveBelow(el, info) {
    if (!el || el.getAttribute('data-mff-moved')) return;
    var a = anchorAfterBuy(info); if (!a || !a.parentNode) return;
    var last = a;
    while (last.nextElementSibling && last.nextElementSibling.getAttribute('data-mff-moved')) last = last.nextElementSibling;
    el.setAttribute('data-mff-moved', '1'); el.classList.add('mff-pdpm-after');
    last.parentNode.insertBefore(el, last.nextSibling);
  }

  /* 3. Find my size next to the Size label */
  function sizeLink(info) {
    var sg = q('#mff-trust-size-guide', info);
    if (!sg || sg.classList.contains('mff-pdpm-sg')) return;
    var row = q('.mp-size-row', info); if (!row) return;
    var label = row.previousElementSibling;
    if (!label || !/mp-var-label/.test(label.className)) return;
    sg.classList.add('mff-pdpm-sg');
    row.parentNode.insertBefore(sg, row.nextSibling);
    var a = q('a[href="#mff-trust-size-guide"]', label);
    if (!a) { a = document.createElement('a'); a.href = '#mff-trust-size-guide'; label.appendChild(a); }
    a.className = 'mff-pdpm-fms'; a.removeAttribute('style'); a.textContent = L('fms', 'Find my size');
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var open = sg.classList.toggle('open');
      a.textContent = open ? L('hideSg', 'Hide size guide') : L('fms', 'Find my size');
    });
  }

  /* 4. sticky Add to Cart */
  var bar, real, btn, priceEl, optEl, raf = 0;
  function optText(info) {
    var parts = [];
    [].slice.call(info.querySelectorAll('[id^="mp-opt-"]')).forEach(function (el) { var t = (el.textContent || '').trim(); if (t) parts.push(t); });
    return parts.join(' · ');
  }
  function syncBar(info) {
    var p = q('#mp-price');
    var pt = p ? (p.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (priceEl.textContent !== pt) priceEl.textContent = pt;
    var ot = optText(info);
    if (optEl.textContent !== ot) optEl.textContent = ot;
    var t = (real.textContent || '').replace(/\s+/g, ' ').trim();
    var off = !!real.disabled || /sold out|unavailable|slutsåld|ausverkauft|agotado/i.test(t);
    var bt = off ? L('soldOut', 'Sold out') : L('atc', 'Add to Cart');
    if (btn.textContent !== bt) btn.textContent = bt;
    btn.disabled = off;
  }
  function dockOffset() {
    var d = q('mobile-dock');
    if (!d) return 0;
    var s = getComputedStyle(d);
    if (s.visibility === 'hidden' || s.display === 'none') return 0;
    var r = d.getBoundingClientRect();
    return r.top < window.innerHeight ? Math.max(0, Math.round(window.innerHeight - r.top)) : 0;
  }
  function place() {
    raf = 0;
    var b = dockOffset();
    bar.style.bottom = b + 'px';
    document.documentElement.style.setProperty('--mff-sticky-bottom', b + 'px');
    var r = real.getBoundingClientRect();
    var visible = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight - b - 60;
    var show = !visible && window.scrollY > 250;
    bar.classList.toggle('on', show);
    document.body.classList.toggle('mff-sticky-on', show);
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(place); }
  function sticky(info) {
    if (q('.mff-sticky')) return;
    real = q('.mp-add-cart', info); if (!real) return;
    bar = document.createElement('div'); bar.className = 'mff-sticky';
    bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = '<div class="mff-sticky__info"><span class="mff-sticky__price"></span><span class="mff-sticky__opt"></span></div><button type="button" class="mff-sticky__btn">' + L('atc', 'Add to Cart') + '</button>';
    document.body.appendChild(bar);
    btn = q('.mff-sticky__btn', bar); priceEl = q('.mff-sticky__price', bar); optEl = q('.mff-sticky__opt', bar);
    btn.addEventListener('click', function () {
      if (btn.disabled) { real.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      real.click();
    });
    syncBar(info);
    var mo = new MutationObserver(function () { syncBar(info); });
    var p = q('#mp-price'); if (p) mo.observe(p, { childList: true, characterData: true, subtree: true });
    mo.observe(real, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    [].slice.call(info.querySelectorAll('[id^="mp-opt-"]')).forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    place();
  }

  function run() {
    var info = q('.mp-info');
    if (!info || !q('.mp-add-cart', info)) return false;
    css();
    movePrice(info);
    moveBelow(q('.mp-similar', info), info);
    moveBelow(q('.mff-x'), info);
    sizeLink(info);
    sticky(info);
    return true;
  }

  /* The cross-sell card is added a moment after load by mff-conversion.js;
     keep checking briefly so it is moved when it appears. */
  var n = 0;
  var iv = setInterval(function () {
    n++;
    var ok = run();
    var x = q('.mff-x');
    if ((ok && x && x.getAttribute('data-mff-moved')) || n > 40) clearInterval(iv);
  }, 250);
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
